var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.33 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0645ad;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,6A1,1,0,0,0,1,8H12.93L8.65,12.29a1,1,0,1,0,1.42,1.42l6-6a1,1,0,0,0,.25-.41.9.9,0,0,0,0-.16,1.31,1.31,0,0,0,0-.28.9.9,0,0,0,0-.16A1,1,0,0,0,16,6.29l-6-6A1,1,0,1,0,8.65,1.71L12.93,6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSeta);
export default __webpack_public_path__ + "static/media/ico-seta.0eca468a0a4e093a513aa58224b879c7.svg";
export { ForwardRef as ReactComponent };